// === Theme types === //
let DataType;

(function (DataType) {
  DataType["Point"] = "Point";
  DataType["BarGroup"] = "BarGroup";
  DataType["Bar"] = "Bar";
})(DataType || (DataType = {}));

let ChartState;

(function (ChartState) {
  ChartState["Loading"] = "Loading";
  ChartState["Error"] = "Error";
  ChartState["Success"] = "Success";
})(ChartState || (ChartState = {}));

let InternalChartType;

(function (InternalChartType) {
  InternalChartType["Bar"] = "Bar";
  InternalChartType["Combo"] = "Combo";
  InternalChartType["Line"] = "Line";
})(InternalChartType || (InternalChartType = {}));

let Hue;

(function (Hue) {
  Hue["Teal"] = "Teal";
  Hue["Blue"] = "Blue";
  Hue["Indigo"] = "Indigo";
  Hue["Purple"] = "Purple";
  Hue["Magenta"] = "Magenta";
  Hue["Orange"] = "Orange";
  Hue["Yellow"] = "Yellow";
})(Hue || (Hue = {}));

export { ChartState, DataType, Hue, InternalChartType };
